import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table";
import AccountSettings from "../../../../components/venture/AccountSettings";
import { selectSubscriptionsListItems } from "../../../../redux/subscriptions/selector";
import { dbaasSubscriptions } from "../../../../redux/dbaas-subscriptions/action";
import { subscriptions } from "../../../../redux/subscriptions/action";
import { selectDbaasSubscriptionsListItems } from "../../../../redux/dbaas-subscriptions/selector";





const DbaasSubscriptions = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const subscriptionsItems = useSelector(selectDbaasSubscriptionsListItems)
     const SubscriptionsItems = useSelector(selectSubscriptionsListItems)
   
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
  
          { field: 'Name', headerName: 'Name',searchField: 'Name', filter: true,
            filterType: 'text' },
          { field: 'Email', headerName: 'Email',searchField: 'Email', filter: true,
            filterType: 'text' },
          { field: 'PhoneNumber', headerName: 'PhoneNumber',searchField: 'PhoneNumber', filter: false},
          { field: 'Validity', headerName: 'Validity',searchField: 'Validity', filter: false },
          { field: 'OwnerName', headerName: 'Subscription',searchField: 'OwnerName', filter: false },
          { field: 'CreatedOnUtc', headerName: 'Start Date', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'End Date', isDateValueFormat: true },
          
    
        ]);
      }
      const handleReloadData = () => {
        dispatch(dbaasSubscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
            "Filters": [
                {
                  "FieldName": "NpSubscriptionId",
                  "FilterOperatorId": 1,
                  "FieldValue": SubscriptionsItems?.result?.items[0]?.Id,
                  "FieldType": "number"
                }
              ],
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const fetchSubscriptions=()=>{
        dispatch(dbaasSubscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
            "Filters": [
                {
                  "FieldName": "NpSubscriptionId",
                  "FilterOperatorId": 1,
                  "FieldValue": SubscriptionsItems?.result?.items[0]?.Id,
                  "FieldType": "number"
                }
              ],
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        }}))
      }
     
      useEffect(() => {
        dispatch(
          subscriptions.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/np-subscriptions/list`,
            entity: 'subscriptions',
            jsonData: {
              PageNumber: pageData,
              PageSize: pageSize,
              SortField: 'Id',
              SortOrder: 'desc',
            },
          })
        );
        createColumnDefs();
      }, [pageData, pageSize]);
      
      useEffect(() => {
        if (SubscriptionsItems?.result?.items?.[0]?.Id) {
          fetchSubscriptions();
        }
      }, [SubscriptionsItems, pageData, pageSize]);
   
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
	return (
    <>
      <div className="h-screen flex flex-col justify-between items-stretch bg-white">
            <div className="flex flex-row ">
            <AccountSettings />
            <div className="w-3/4  justity-center items-center">
                <div className="w-full  rounded-lg  flex flex-col  text-black p-5">
                    <div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
                        <div className="flex w-full flex-col items-start justify-between text-xl" >
                            DBAAS Subscriptions
                        </div>
                       
                    </div>
    {subscriptionsItems?.isLoading ?  <PageLoader />: 
		<Table  
   columnData={columnDefs} rowData={subscriptionsItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={subscriptionsItems?.result?.pagination}  additionButtons={additionButtons} />
     
  }
  </div></div></div></div>
  </> 
	);
};

export default DbaasSubscriptions;


